import { SET_ORIGINAL_USER_CART } from "../actions/types";
export default function originalUserCartReducer(state = [], action) {
    switch (action.type) {
        case SET_ORIGINAL_USER_CART: {
            return action.payload.map((user) => ({ ...user, currentReduxQuantity: user.quantity }));
        }
        default:
            return state;
    }
}
